import { render, staticRenderFns } from "./MemberStatusBadge.vue?vue&type=template&id=37ffc166&"
import script from "./MemberStatusBadge.vue?vue&type=script&lang=ts&"
export * from "./MemberStatusBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports